export const VIEWED_CLUSTERS_VERSION = 1;
export const VIEWED_CLUSTERS_LIMIT = 1000;
export const LOCAL_STORAGE_KEY = `map-search-frontend.viewedClusters.v${VIEWED_CLUSTERS_VERSION}`;
